// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress-bar{background:var(--secondary-color-4);height:.375rem;min-width:6.25rem;position:relative}.progress-bar__value{background:var(--secondary-color);bottom:0;left:0;max-width:100%;position:absolute;top:0;transition:width .3s var(--asphalte-animation-function);will-change:width}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
